import { Validators } from "@angular/forms";

export const REGEX_PASSWORD = Validators.pattern(/(?=^.{12,}$)(?=.*\d)(?=.*\W+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/);
